<template>
  <div class="">
    <section class="home mt-16 flex items-center">
      <div class="w-full lg:w-1/2">
        <h1 class="hero-text font-medium text-black">Explore Africa's <br> Economic Data <br> <span
            class="italic font-normal ">—with
            Intelligence</span></h1>
        <p class="hero-desc font-normal">Uncover insights hidden in public data and make informed decisions faster than
          ever. With
          Klevaar, you can explore, visualize, and validate information with ease.</p>
        <div class="flex flex-col lg:flex-row gap-x-5">
          <router-link to="/search"
            class="flex items-center justify-between lg:justify-end btn-link bg-brandCol rounded-full">
            <span class="font-normal text-white">Try Data Search</span>
            <div class="btn-inner btn-inner-extra flex items-center justify-center rounded-full">
              <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
            </div>
          </router-link>
          <router-link to="/fact-checking"
            class="flex items-center justify-between lg:justify-end btn-link btn-link-secondary rounded-full">
            <span class="text-brandCol font-normal">Try Fact-Checking</span>
            <div class="btn-inner bg-brandCol flex items-center justify-center rounded-full">
              <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
            </div>
          </router-link>
        </div>
        <section>
          <p class="mb-1 font-semibold">Countries available in beta</p>
          <div class="grid grid-cols-2 lg:grid-cols-3 gap-x-0 countries-list">
            <p v-for="country in countries" :key="country" class="country-item inline">{{ country }}</p>
          </div>
        </section>
      </div>
      <div class="w-1/2 hidden lg:block">
        <img src="../../../assets/svg/home-hero.svg" alt="Button Icon" />
      </div>
    </section>

    <section class="at-kwerty bg-opacity-20 flex items-center justify-center">
      <h2>At Klevaar, we use advanced AI to transform access to economic data, delivering insights that drive growth
        and
        transparency while connecting Africa to the numbers that matter.</h2>
    </section>

    <section class="products flex flex-col items-center">
      <header>
        <span class="uppercase text-brandCol block">products</span>
        <h3 class="">Explore Powerful Features
          Built for Data-Driven Decisions</h3>
        <p class="text-center">Our platform includes dynamic search tools, engaging visualizations, and reliable
          fact-checking—all tailored
          to African economic data. Discover how Klevaar empowers your data exploration</p>
      </header>

      <div class="flex items-center justify-between ai-power w-full">
        <div class="w-full left-side flex flex-col justify-evenly">
          <header>
            <span class="uppercase">Advanced Data Search</span>
            <h4>AI Powered Insights: Explore Comprehensive Public Data Effortlessly</h4>
            <p>Uncover In-Depth Statistics, Visualizations, and Reliable Datasets across African Countries and 30,000+
              Indicators on Africa’s Premier Public Data Hub—Your Source for Unrestricted Knowledge.</p>
          </header>
          <router-link to="/search" class="flex items-center justify-end btn-link bg-white rounded-full">
            <span id="btn-text">Try it now</span>
            <div class="btn-inner btn-inner-extra flex items-center justify-center rounded-full">
              <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
            </div>
          </router-link>
        </div>
        <div class="w-full hidden lg:block">
          <img src="../../../assets/svg/ai-poweredHero.svg" alt="Button Icon" />
        </div>
      </div>

      <div class="flex flex-col lg:flex-row gap-5 twin-product w-full">
        <section class="w-full left-side flex flex-col justify-center items-center">
          <span class="signature-desc uppercase text-center block">country dashboard</span>
          <h4 class="text-center">Insights by Country, Simplified</h4>
          <p class="text-center">Gain expert insights into country-specific data with dynamic dashboards. Compare
            metrics, track
            performance, and uncover opportunities for growth across African nations.</p>
          <img class="img" src="../../../assets/svg/insightHero.svg" alt="Button Icon" />
          <router-link to="#"
            class="flex items-center justify-center btn-link bg-brandCol rounded-full pointer-events-auto">
            <span id="btn-text-2" class="block">Comming Soon</span>
            <!-- <div class="btn-inner bg-black flex items-center justify-center rounded-full">
              <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
            </div> -->
          </router-link>
        </section>
        <section class="w-full right-side flex flex-col justify-center items-center">
          <span class="signature-desc uppercase text-center block">fact checking</span>
          <h4 class="text-center">Get the Facts Right, Every Time</h4>
          <p class="text-center">Strengthen your work with precise, data-backed facts. Our AI-powered fact-checking tool
            analyzes statements and cross-references them with accurate data, ensuring you always stay credible. </p>
          <img class="img" src="../../../assets/svg/factsCheckHero.svg" alt="Button Icon" />
          <router-link to="/fact-checking" class="flex items-center justify-end btn-link bg-brandCol rounded-full">
            <span id="btn-text-2">Get Started</span>
            <div class="btn-inner bg-black flex items-center justify-center rounded-full">
              <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
            </div>
          </router-link>
        </section>
      </div>
    </section>

    <section class="committed flex justify-center items-center">
      <h2 class="">We’re committed to telling Africa’s economic story through accessible, reliable, and actionable data.
        With
        Klevaar, you’re not just accessing data—you’re unlocking potential.</h2>
    </section>

    <section class="why-kwerty flex flex-col items-center">
      <header class="">
        <span class="uppercase text-brandCol block text-center">why choose Klevaar?</span>
        <h3 class="">Tailored for Africa</h3>
        <p class="text-center">Klevaar is more than a data platform—it’s a gateway to Africa’s economic future.
          Discover
          the
          benefits of using Klevaar for your data exploration and fact-checking needs.</p>
      </header>
      <div class="flex flex-col lg:flex-row w-full">
        <section class="left-kwerty flex flex-col items-center">
          <div class="map flex flex-col items-center w-full">
            <img src="../../../assets/images/africaMap.png" alt="map image" />
            <h5>Use Klevaar as a reliable source for data on African economies for research papers and case studies.
            </h5>
          </div>
          <div class="reliable">
            <h5>Reliable African fiscal’s datasets for diverse industry consumption</h5>
          </div>
          <div class="fact-check w-full">
            <h5>Fact-check content for accuracy and reliability.</h5>
          </div>
        </section>
        <section class="right-kwerty">
          <div class="top-sect-right-kwerty gap-4">
            <div class="transform w-full flex flex-col items-center">
              <h5>Transform complex datasets into compelling, easy-to-understand narratives for public awareness and
                engagement.</h5>
              <img src="../../../assets/images/transformComp.png" alt="transform image" />
            </div>
            <div class="compare w-full relative">
              <div class="overlay h-full w-full absolute top-0 left-0">
                <h5>Compare fiscal and economic metrics across countries to identify competitive advantages or expansion
                  opportunities.</h5>
              </div>
            </div>
            <div class="robust w-full">
              <h5>Robust <br>
                Data Library</h5>
              <p class="text-white">Use Klevaar curated, high-quality African fiscal data to fine-tune LLMs for
                region-specific economic
                content generation and query handling.</p>
            </div>
            <div class="access w-full flex flex-col items-center">
              <img src="../../../assets/images/accessCurated.png" alt="transform image" />
              <p>Access curated datasets to enhance learning and academic projects focused on African
                economies.</p>
            </div>
          </div>
          <div class="kwerty-cut flex items-center justify-center">
            <h4>Klevaar cutting-edge tools make data actionable, bridging the gap between numbers and impactful
              decision-making across Africa.</h4>
          </div>
        </section>
      </div>
    </section>

    <section class="partnered flex flex-col items-center">
      <header>
        <h3 class="text-black">We’ve partnered with <br>
          top government institutions and agencies all over the world.</h3>
        <p class="text-center">Every dataset is gotten directly from verified sources of government and world data.</p>
      </header>
      <div class="flex items-center justify-center gap-16 lg:gap-32">
        <img src="../../../assets/svg/partners/budgit.svg" alt="partnered image" />
        <img src="../../../assets/svg/partners/enugu.svg" alt="partnered image" />
        <img src="../../../assets/svg/partners/fitila.svg" alt="partnered image" />
        <img src="../../../assets/svg/partners/univelcity.svg" alt="partnered image" />
      </div>
    </section>

    <section class="faq flex justify-center items-center flex-col lg:flex-row">
      <div class="faq-det w-full">
        <span class="uppercase">faq</span>
        <h3 class="text-black">Frequently asked
          questions</h3>
        <p class="text-black faq-subtext">Discover responses to common asked questions <br> about our product and
          services.</p>
        <div class="faq-cta hidden lg:block">
          <div class="flex items-center gap-3">
            <img src="../../../assets/svg/question-icon.svg" alt="question Icon" />
            <p class="text-black">Need more assistance?</p>
          </div>
          <router-link to="/contact-us"
            class="flex items-center justify-end btn-link btn-link-secondary bg-white rounded-full">
            <span id="btn-text">Contact Us</span>
            <div class="btn-inner btn-inner-extra flex items-center justify-center rounded-full">
              <img src="../../../assets/svg/btn-arrow.svg" alt="Button Icon" />
            </div>
          </router-link>
        </div>
      </div>
      <div class="faq-quest w-full">
        <FaqItem title="How do I get started with Klevaar?"
          description="Getting started with Klevaar is easy. Simply create an account, log in, and start exploring our vast database of economic data." />
        <FaqItem title="How do I fact-check a statement?"
          description="To fact-check a statement, simply input the statement into our fact-checking tool. Our AI will cross-reference the statement with accurate data to determine its credibility." />
        <FaqItem title="How do I access country-specific data?"
          description="To access country-specific data, navigate to the Country Dashboard on our platform. Here, you can compare metrics, track performance, and gain insights into individual nations." />
        <FaqItem title="How do I visualize data on Klevaar?"
          description="Visualizing data on Klevaar is simple. Use our Advanced Data Search tool to explore comprehensive public data and generate engaging visualizations that help you uncover insights." />
      </div>
    </section>

    <section class="build-africa">
      <h1 class="text-center">Building Africa’s Future <br> with <span class="better">Better Data</span></h1>
      <p>We believe accessible data is the foundation of growth and innovation in Africa. Klevaar is committed to
        making
        African economic data a tool for progress.</p>
    </section>
    <Footer />
  </div>
</template>

<script>
import Footer from '../../../components/Footer/Footer.vue';
import FaqItem from '../../../components/Home/faq/FaqItem.vue';
import Home from './Home';

export default {
  name: 'Home',
  components: {
    FaqItem,
    Footer,
    Home
  },
  data() {
    return {
      countries: [
        'Nigeria',
        'Kenya',
        'South Africa',
        'Ghana',
        'Uganda',
        'Tanzania',
        'Rwanda',
        'Zambia',
        'Zimbabwe',
        'Senegal',
        'Côte d’Ivoire',
        'Cameroon',
        'Mali',
        'Burkina Faso',
        'Angola'
      ]
    };
  }
}
</script>

<style lang="scss" scoped src="./Home.scss" />